/**
 * Idempotency types and constants.
 */

export interface IdempotencyRecord {
  /** Chiave univoca (es: "idem_create_order_abc123_xyz") */
  key: string;
  /** Tipo operazione */
  operationType: 'create_order' | 'update_order' | 'delete_order';
  /** Hash del payload request (per detect riuso con dati diversi) */
  requestHash: string;
  /** ID entità locale */
  localEntityId: string;
  /** ID entità server (dopo sync riuscita) */
  serverEntityId: string | null;
  /** Stato */
  status: 'pending' | 'completed' | 'failed';
  /** Response cached (JSON) */
  cachedResponse: string | null;
  /** HTTP status code della response */
  responseStatus: number | null;
  /** Errore se failed */
  error: string | null;
  /** Timestamp creazione */
  createdAt: string;
  /** Timestamp ultima modifica */
  updatedAt: string;
  /** Scadenza (dopo cui può essere riusata) */
  expiresAt: string;
}

export interface IdempotencyCheckResult {
  /** Se true, operazione già processata */
  isDuplicate: boolean;
  /** Se duplicate, la response cached */
  cachedResponse?: unknown;
  /** Se duplicate, lo status HTTP cached */
  cachedStatus?: number;
  /** Se duplicate ma con dati diversi */
  isConflict?: boolean;
  /** Record esistente (se trovato) */
  existingRecord?: IdempotencyRecord;
}

export interface CreateIdempotencyKeyOptions {
  /** Tipo operazione */
  operationType: IdempotencyRecord['operationType'];
  /** ID locale dell'entità */
  localEntityId: string;
  /** Payload della richiesta (per hash) */
  payload: unknown;
  /** TTL in ore (default: 24) */
  ttlHours?: number;
}

export const IDEMPOTENCY_KEY_TTL_HOURS = 24;
export const IDEMPOTENCY_KEY_PREFIX = 'idem';
